module.exports = __webpack_public_path__ + "img/medio4.4a9b4fdc.jpg";